import { Link } from 'react-router-dom';
import { serviceCategories } from '@/mocks/home';

export default function ServiceSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs font-semibold text-primary-500 tracking-widest uppercase mb-2 font-label">产品服务</p>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            全方位数字服务生态
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            覆盖多元领域，以科技创新驱动服务升级，满足您在不同场景下的个性化需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {serviceCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-4 right-4">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-lg bg-primary-500/90 flex items-center justify-center">
                      <i className={`${cat.icon} text-white text-sm`}></i>
                    </div>
                    <span className="text-white font-semibold text-sm">{cat.name}</span>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-500 leading-relaxed mb-3">{cat.description}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{cat.items} 项服务</span>
                  <span className="text-xs text-primary-500 font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    了解更多 <i className="ri-arrow-right-line text-[10px]"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-sm text-foreground-600 hover:border-primary-400 hover:text-primary-500 transition-all duration-200"
          >
            查看全部服务 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}